import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING } from "const"
import { StateType } from "client/utils"
import {
    StoreType,
    LoadQidDatapoints,
    LoadQidModelSafetyFunctionById,
    DeleteQidModelOption,
    setQidModelDeleteOption,
    setQidModelReloadList,
    setQidDatapointReloadList,
} from "client/store"
import {
    Button,
    ConfirmWrapper,
    Confirm,
    ConfirmTitle,
    ConfirmDescription,
    ConfirmBottom,
    SpinnerIcon,
    Loader,
} from "client/components"


export const ConfirmDeleteOption = () => {
    const product = useSelector((state: StoreType) => state.qidProduct.productView)
    const option = useSelector((state: StoreType) => state.qidModel.deleteOption)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [datapoints, setDatapoints] = useState<number>(0)
    const [loadState, setLoadState] = useState<StateType>(IDLE)
    const [deleteState, setDeleteState] = useState<StateType>(IDLE)

    useEffect(() => {
        if (!option) return
        setLoadState(PENDING)
        LoadQidDatapoints({
            optionId: option.id,
        }).then((res) => {
            setDatapoints(res.length)
            setLoadState(IDLE)
        })
    }, [option])

    const onCancel = () => {
        dispatch(setQidModelDeleteOption(null))
    }

    const onConfirmDelete = () => {
        setDeleteState(PENDING)
        LoadQidModelSafetyFunctionById(option.safetyFunctionId).then((safetyFunction) => (
            DeleteQidModelOption(option.id, option.safetyFunctionId, safetyFunction.modelId, product.id).then(() => {
                setDeleteState(IDLE)

                dispatch(setQidModelDeleteOption(null))

                dispatch(setQidModelReloadList(false))
                dispatch(setQidDatapointReloadList(false))
                setTimeout(() => {
                    dispatch(setQidModelReloadList(true))
                    dispatch(setQidDatapointReloadList(true))
                }, 0)
            })
        ))
    }

    return (
        <ConfirmWrapper show={!!option} onClose={onCancel}>
            <Confirm>
                <ConfirmTitle>{option ? option.name : ""}</ConfirmTitle>
                <ConfirmDescription>
                    {
                        loadState === PENDING
                            ? <Loader />
                            : (datapoints > 0 ? lang.deleteOptionDatapointsConfirm : lang.deleteOptionConfirm)
                    }
                </ConfirmDescription>

                <ConfirmBottom>
                    <Button variant="success" row disabled={deleteState === PENDING} onClick={onConfirmDelete}>
                        {deleteState === PENDING ? <SpinnerIcon /> : lang.confirm}
                    </Button>
                    <Button row onClick={onCancel}>
                        {lang.cancel}
                    </Button>
                </ConfirmBottom>
            </Confirm>
        </ConfirmWrapper>
    )
}
export default ConfirmDeleteOption
